import { Box, styled } from "@mui/material";

export const TableContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 'auto',
  flex: 0,
  border: `1px solid ${theme.palette.grey[500]}`,
  borderRadius: theme.spacing(5),
}));
